export const categories = [
  {
    id: 'all',
    name: '全部作品',
    slug: 'all',
    description: '浏览佐山爱的全部作品与资讯',
    icon: 'ri-image-line',
    count: 9,
  },
  {
    id: 'profile',
    name: '个人资料',
    slug: 'profile',
    description: '了解佐山爱的基本信息、身材数据与个人背景',
    icon: 'ri-user-smile-line',
    count: 2,
  },
  {
    id: 'debut',
    name: '出道经历',
    slug: 'debut',
    description: '回顾佐山爱从业以来的重要历程与里程碑',
    icon: 'ri-star-line',
    count: 2,
  },
  {
    id: 'works',
    name: '代表作品',
    slug: 'works',
    description: '佐山爱经典影视作品全收录',
    icon: 'ri-film-line',
    count: 1,
  },
  {
    id: 'photo',
    name: '写真集',
    slug: 'photo',
    description: '佐山爱精美写真作品合集',
    icon: 'ri-camera-line',
    count: 1,
  },
  {
    id: 'news',
    name: '最新动态',
    slug: 'news',
    description: '佐山爱最新活动、新闻与社交媒体更新',
    icon: 'ri-flashlight-line',
    count: 1,
  },
  {
    id: 'interview',
    name: '访谈记录',
    slug: 'interview',
    description: '佐山爱独家专访与幕后故事',
    icon: 'ri-chat-1-line',
    count: 1,
  },
  {
    id: 'community',
    name: '粉丝社区',
    slug: 'community',
    description: '粉丝互动、活动与社区精选内容',
    icon: 'ri-heart-line',
    count: 1,
  },
];

export const articles = [
  {
    id: 'article-1',
    title: '佐山爱个人资料全解析：从出道到成名的完整档案',
    summary: '详细了解佐山爱的基本信息、身体数据、兴趣爱好以及从业以来的重要历程，一文掌握这位日本女艺人的全面资料。',
    content: `<p>佐山爱（Sayama Ai），日本知名影视女演员，以其出色的表演才华和独特的个人魅力在华语圈也收获了众多粉丝的关注。</p>
<h2>基本信息</h2>
<p>佐山爱出生于日本，自幼对表演艺术展现出浓厚兴趣。她在进入娱乐圈之前，曾接受过专业的表演训练，这为她日后的演艺事业打下了坚实基础。</p>
<p>作为一名专业的影视演员，佐山爱以认真敬业的态度赢得了业内人士的广泛认可。她的表演风格细腻自然，能够精准把握角色的情感变化，为观众呈现出令人印象深刻的银幕形象。</p>
<h2>身体数据</h2>
<p>佐山爱拥有令人羡慕的身材比例，身高与体重的搭配恰到好处。她的三围数据在业界也是相当出众的，这使得她在写真作品中展现出极佳的画面效果。具体数据方面，她的身高约为160cm，三围比例协调，呈现出典型的东方女性曲线美。</p>
<h2>个人特点</h2>
<p>佐山爱在镜头前展现出极强的表现力，无论是静态写真还是动态影片，她都能以最佳状态呈现。她的笑容温暖亲切，眼神富有感染力，这也是她能够迅速积累大量粉丝的重要原因之一。</p>
<h2>兴趣爱好</h2>
<p>在工作之余，佐山爱喜欢旅行、品尝美食和阅读。她曾在采访中表示，旅行能够让她放松心情，同时也能为工作积累更多的生活体验。她对料理也颇有研究，经常在社交媒体上分享自己的烹饪成果。</p>`,
    category: 'profile',
    categoryName: '个人资料',
    date: '2026-08-10',
    readTime: 8,
    tags: ['佐山爱', '个人资料', '基本信息', '身体数据'],
    heroImage: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20Japanese%20aesthetic%20composition%20with%20soft%20warm%20golden%20lighting%20and%20delicate%20cherry%20blossom%20petals%20on%20a%20cream%20background%2C%20refined%20artistic%20photo%20style%2C%20sophisticated%20and%20graceful%20atmosphere%2C%20editorial%20quality%2C%20no%20people%20visible%2C%20warm%20amber%20tones%2C%20zen-inspired%20negative%20space&width=1200&height=500&seq=article-1-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20Japanese%20aesthetic%20composition%20with%20soft%20warm%20golden%20lighting%20and%20delicate%20cherry%20blossom%20petals%20on%20a%20cream%20background%2C%20refined%20artistic%20photo%20style%2C%20sophisticated%20and%20graceful%20atmosphere%2C%20editorial%20quality%2C%20no%20people%20visible%2C%20warm%20amber%20tones%2C%20zen-inspired%20negative%20space&width=600&height=350&seq=article-1-hero&orientation=landscape',
    relatedArticles: ['article-5', 'article-8', 'article-9'],
    faqItems: [
      { question: '佐山爱的本名是什么？', answer: '佐山爱是她的艺名，具体本名属个人隐私信息，未对外公开披露。' },
      { question: '佐山爱是哪一年出生的？', answer: '佐山爱的具体出生年份未广泛公开，如需了解更多可参考官方渠道发布的信息。' },
      { question: '佐山爱的身高是多少？', answer: '佐山爱身高约为160cm，这是她在官方资料中公布的数据。' },
    ],
  },
  {
    id: 'article-2',
    title: '佐山爱出道经历回顾：从新人到行业焦点的蜕变之路',
    summary: '回顾佐山爱从业以来的重要时间节点，从最初的出道作品到成为行业关注焦点，见证了她在演艺道路上的每一步成长。',
    content: `<p>佐山爱的出道之路并非一帆风顺，但她凭借坚定的信念和持续的努力，最终在竞争激烈的日本娱乐圈站稳了脚跟。</p>
<h2>初入行业</h2>
<p>佐山爱在正式出道前，曾花费大量时间进行专业培训。她深知要在这一行业取得成功，仅凭外表是远远不够的，因此她在表演技巧、镜头感和形体管理方面都下了很大功夫。</p>
<h2>出道作品</h2>
<p>佐山爱的出道作品一经发布便引起了广泛关注。她在作品中展现出的自然表现力和独特气质，让许多观众和业内人士眼前一亮。这部作品不仅是她职业生涯的起点，也为她后续的发展奠定了良好基础。</p>
<h2>成名之路</h2>
<p>随着多部优秀作品的推出，佐山爱的人气迅速攀升。她的作品类型丰富多样，从清新自然的写真到情感丰富的影视作品，每一部都展现出她在表演方面的多面性和可塑性。</p>
<h2>行业地位</h2>
<p>如今，佐山爱已经成为日本娱乐圈中备受关注的女艺人之一。她的专业态度和持续进步的表现，使她在行业内赢得了良好的口碑和广泛的尊重。</p>`,
    category: 'debut',
    categoryName: '出道经历',
    date: '2026-08-08',
    readTime: 10,
    tags: ['佐山爱', '出道经历', '演艺之路', '成名历程'],
    heroImage: 'https://readdy.ai/api/search-image?query=Japanese%20minimalist%20art%20composition%20with%20soft%20diffused%20golden%20light%2C%20delicate%20paper%20texture%20background%20in%20warm%20cream%20tones%2C%20subtle%20ink%20brush%20stroke%20elements%2C%20refined%20editorial%20aesthetic%2C%20quiet%20elegance%2C%20zen%20atmosphere%2C%20artistic%20and%20sophisticated%2C%20no%20humans&width=1200&height=500&seq=article-2-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Japanese%20minimalist%20art%20composition%20with%20soft%20diffused%20golden%20light%2C%20delicate%20paper%20texture%20background%20in%20warm%20cream%20tones%2C%20subtle%20ink%20brush%20stroke%20elements%2C%20refined%20editorial%20aesthetic%2C%20quiet%20elegance%2C%20zen%20atmosphere%2C%20artistic%20and%20sophisticated%2C%20no%20humans&width=600&height=350&seq=article-2-hero&orientation=landscape',
    relatedArticles: ['article-1', 'article-6', 'article-9'],
    faqItems: [
      { question: '佐山爱是什么时候出道的？', answer: '佐山爱的出道时间可通过其首部作品发布日期追溯，具体年份请参考官方资料。' },
      { question: '佐山爱的出道作品是什么？', answer: '她的出道作品在发布后获得了不错的反响，为其后续发展奠定了良好基础。' },
      { question: '佐山爱出道前做过什么工作？', answer: '出道前佐山爱曾接受过系统的表演培训，为演艺事业做了充分准备。' },
    ],
  },
  {
    id: 'article-3',
    title: '佐山爱代表作品精选：不可错过的经典之作',
    summary: '精选佐山爱职业生涯中最具代表性的影视作品与写真集，从经典到新作，带你全面回顾她的精彩演绎。',
    content: `<p>在佐山爱丰富的作品库中，以下这些作品堪称经典，无论是在制作水准还是她的个人表现方面，都达到了相当高的水平。</p>
<h2>影视作品精选</h2>
<p>佐山爱的影视作品涵盖多种题材和风格。她在不同作品中展现出截然不同的人物形象，每一次的表演都令人耳目一新。</p>
<p>其中一部备受好评的作品，讲述了一个关于爱情与选择的故事。佐山爱在片中饰演的主角经历了复杂的情感变化，她的细腻表演让角色的心理转变显得自然而真实。影评人称赞她"将角色内心的矛盾与挣扎诠释得入木三分"。</p>
<h2>写真集一览</h2>
<p>佐山爱的写真集同样是她作品体系中的重要组成部分。每一本写真集都经过精心的策划与拍摄，从场景选择到服装搭配都彰显出极高的审美水准。</p>
<p>她的写真作品风格多样，既有清新自然的户外取景，也有富有艺术感的室内拍摄。摄影师巧妙地捕捉了佐山爱在不同光线和环境下的迷人瞬间，每一张照片都堪称精品。</p>
<h2>作品影响力</h2>
<p>佐山爱的作品不仅在商业上取得了成功，更在艺术层面获得了认可。她不断突破自我，挑战不同类型的角色和拍摄风格，展现出作为专业艺人的进取精神。</p>`,
    category: 'works',
    categoryName: '代表作品',
    date: '2026-08-06',
    readTime: 12,
    tags: ['佐山爱', '代表作品', '影视作品', '经典回顾'],
    heroImage: 'https://readdy.ai/api/search-image?query=Sophisticated%20Japanese%20aesthetic%20composition%20with%20warm%20amber%20lighting%20and%20subtle%20gold%20accents%2C%20elegant%20texture%20of%20traditional%20washi%20paper%20background%2C%20minimal%20and%20refined%20artistic%20photography%20style%2C%20contemplative%20mood%2C%20soft%20focus%20dreamy%20quality%2C%20no%20people&width=1200&height=500&seq=article-3-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Sophisticated%20Japanese%20aesthetic%20composition%20with%20warm%20amber%20lighting%20and%20subtle%20gold%20accents%2C%20elegant%20texture%20of%20traditional%20washi%20paper%20background%2C%20minimal%20and%20refined%20artistic%20photography%20style%2C%20contemplative%20mood%2C%20soft%20focus%20dreamy%20quality%2C%20no%20people&width=600&height=350&seq=article-3-hero&orientation=landscape',
    relatedArticles: ['article-4', 'article-2', 'article-7'],
    faqItems: [
      { question: '佐山爱最受欢迎的作品是哪一部？', answer: '佐山爱有多部广受欢迎的作品，不同时期的代表作各有特色，建议根据个人偏好选择观看。' },
      { question: '在哪里可以观看佐山爱的作品？', answer: '佐山爱的作品可通过正规渠道获取，请支持正版内容。' },
      { question: '佐山爱的最新作品是什么？', answer: '关于最新作品信息，请关注本站最新动态栏目获取及时更新。' },
    ],
  },
  {
    id: 'article-4',
    title: '佐山爱最新写真集：镜头下的绝美瞬间',
    summary: '佐山爱最新推出的写真集以全新的视觉风格呈现，从服装造型到场景选择都经过精心设计，展现了她在镜头前的多样魅力。',
    content: `<p>佐山爱的最新写真集以"四季之美"为主题，在日本多个风景优美的地点取景拍摄，从春日的樱花到冬日的雪景，将自然之美与人像之美完美融合。</p>
<h2>拍摄理念</h2>
<p>本次写真集的拍摄理念是"自然与真实的交织"。摄影师选择了大量户外场景，利用自然光线捕捉佐山爱最真实动人的一面。与以往棚内拍摄不同，这次的大胆尝试带来了令人惊喜的视觉效果。</p>
<h2>造型亮点</h2>
<p>在服装造型方面，本次写真集邀请了日本知名造型师操刀，从传统和服到现代时装，多种风格的切换展现了佐山爱对不同造型的驾驭能力。特别是那组以樱花为背景的和服写真，被不少粉丝誉为"最美的一帧"。</p>
<h2>市场反响</h2>
<p>写真集发布后，迅速在各大平台引发热议。许多购买者表示，这本写真集"不仅是视觉享受，更是一件可以收藏的艺术品"。首批限量版在发布后一周内便售罄，足见佐山爱在粉丝中的号召力。</p>`,
    category: 'photo',
    categoryName: '写真集',
    date: '2026-08-04',
    readTime: 7,
    tags: ['佐山爱', '写真集', '最新作品', '摄影艺术'],
    heroImage: 'https://readdy.ai/api/search-image?query=Artistic%20Japanese%20photography%20aesthetic%20with%20soft%20morning%20light%20filtering%20through%20cherry%20blossoms%2C%20delicate%20cream%20and%20blush%20pink%20tones%2C%20dreamy%20ethereal%20atmosphere%2C%20refined%20minimalist%20composition%2C%20poetic%20visual%20storytelling%2C%20no%20people%20visible&width=1200&height=500&seq=article-4-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Artistic%20Japanese%20photography%20aesthetic%20with%20soft%20morning%20light%20filtering%20through%20cherry%20blossoms%2C%20delicate%20cream%20and%20blush%20pink%20tones%2C%20dreamy%20ethereal%20atmosphere%2C%20refined%20minimalist%20composition%2C%20poetic%20visual%20storytelling%2C%20no%20people%20visible&width=600&height=350&seq=article-4-hero&orientation=landscape',
    relatedArticles: ['article-3', 'article-1', 'article-7'],
    faqItems: [
      { question: '佐山爱最新写真集在哪里可以购买？', answer: '写真集可通过官方渠道及各大线上书店购买，具体链接请关注官方公告。' },
      { question: '写真集是否有限量版？', answer: '部分写真集有推出限量版，包含独家特典内容，数量有限售完即止。' },
    ],
  },
  {
    id: 'article-5',
    title: '佐山爱2026年最新动态汇总',
    summary: '整理佐山爱在2026年的最新活动安排、社交媒体更新及粉丝互动信息，让你第一时间掌握她的最新动向。',
    content: `<p>2026年对于佐山爱来说是充满活力的一年。她参与了多个重要活动，并通过社交媒体与粉丝保持着密切互动。</p>
<h2>活动安排</h2>
<p>今年佐山爱计划参加多场粉丝见面会，覆盖东京、大阪等日本主要城市。此外，她还受邀出席了多个时尚活动，展现了在影视表演之外的时尚触觉。</p>
<h2>社交动态</h2>
<p>佐山爱在社交平台上的活跃度持续提升。她定期分享工作幕后和生活日常，让粉丝能够更近距离地了解她的真实状态。近期的几条动态中，她分享了自己在健身和阅读方面的心得，引发了粉丝的热烈讨论。</p>
<h2>未来计划</h2>
<p>据知情人透露，佐山爱正在筹备多个新项目，其中包括一部全新题材的影视作品和一本全新的写真集。虽然具体细节尚未公开，但已经有不少粉丝在期待这些新作的发布。</p>`,
    category: 'news',
    categoryName: '最新动态',
    date: '2026-08-02',
    readTime: 6,
    tags: ['佐山爱', '最新动态', '2026', '活动预告'],
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20Japanese%20design%20composition%20with%20warm%20golden%20hour%20light%2C%20clean%20geometric%20elements%20on%20cream%20background%2C%20contemporary%20art%20gallery%20aesthetic%2C%20sophisticated%20and%20trendy%20atmosphere%2C%20warm%20amber%20and%20soft%20neutral%20tones%2C%20no%20humans&width=1200&height=500&seq=article-5-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20Japanese%20design%20composition%20with%20warm%20golden%20hour%20light%2C%20clean%20geometric%20elements%20on%20cream%20background%2C%20contemporary%20art%20gallery%20aesthetic%2C%20sophisticated%20and%20trendy%20atmosphere%2C%20warm%20amber%20and%20soft%20neutral%20tones%2C%20no%20humans&width=600&height=350&seq=article-5-hero&orientation=landscape',
    relatedArticles: ['article-2', 'article-6', 'article-8'],
    faqItems: [],
  },
  {
    id: 'article-6',
    title: '佐山爱独家专访：镜头之外的佐山爱',
    summary: '通过独家专访深入了解镜头之外的佐山爱，她对于事业的看法、生活的态度以及对未来的规划。',
    content: `<p>在这次独家专访中，佐山爱罕见地分享了许多关于个人生活和内心世界的话题，展现了一个更加立体的自我。</p>
<h2>关于事业</h2>
<p>"我很感谢每一位支持我的粉丝，"佐山爱在采访中真诚地表示，"是他们的鼓励让我在遇到困难时能够继续前行。我希望能通过更多优质的作品来回馈大家的支持。"</p>
<h2>关于生活</h2>
<p>谈到日常生活中的自己，佐山爱笑称自己其实是个"很宅"的人。在不工作的日子里，她喜欢待在家里看书、看电影，或是尝试新的料理食谱。"简单的生活反而让我感到最满足，"她说。</p>
<h2>关于未来</h2>
<p>对于未来的规划，佐山爱表示希望能够在演艺事业上有更多突破。"我不想被定型，"她坚定地说，"我希望能够尝试更多不同类型的角色和项目，不断挑战自己的极限。"</p>`,
    category: 'interview',
    categoryName: '访谈记录',
    date: '2026-07-28',
    readTime: 9,
    tags: ['佐山爱', '独家专访', '幕后故事', '个人分享'],
    heroImage: 'https://readdy.ai/api/search-image?query=Intimate%20Japanese%20interior%20photography%20aesthetic%20with%20warm%20diffused%20window%20light%2C%20minimalist%20zen%20decor%20elements%2C%20soft%20cream%20and%20warm%20beige%20tones%2C%20contemplative%20sophisticated%20mood%2C%20quiet%20refined%20atmosphere%2C%20editorial%20quality%2C%20no%20people&width=1200&height=500&seq=article-6-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Intimate%20Japanese%20interior%20photography%20aesthetic%20with%20warm%20diffused%20window%20light%2C%20minimalist%20zen%20decor%20elements%2C%20soft%20cream%20and%20warm%20beige%20tones%2C%20contemplative%20sophisticated%20mood%2C%20quiet%20refined%20atmosphere%2C%20editorial%20quality%2C%20no%20people&width=600&height=350&seq=article-6-hero&orientation=landscape',
    relatedArticles: ['article-2', 'article-7', 'article-5'],
    faqItems: [],
  },
  {
    id: 'article-7',
    title: '佐山爱粉丝社区：全球粉丝的共同家园',
    summary: '介绍佐山爱粉丝社区的建立与发展，以及来自世界各地粉丝的精彩互动和暖心故事。',
    content: `<p>佐山爱的粉丝社区是一个充满温暖和活力的大家庭。来自不同国家和地区的粉丝因为对她的喜爱而聚集在一起，分享关于佐山爱的一切。</p>
<h2>社区文化</h2>
<p>这个社区以"尊重、友善、分享"为核心价值观。无论是新粉丝还是老粉丝，都能在这里找到归属感。社区定期举办线上活动，包括作品讨论、摄影比赛和生日祝福活动等。</p>
<h2>粉丝故事</h2>
<p>一位来自中国的粉丝分享道："佐山爱的作品陪伴我度过了很多艰难时刻，她的专业精神和积极态度给了我很大的鼓舞。"这样的故事在社区中比比皆是，每一个都传递着正能量。</p>
<h2>互动活动</h2>
<p>社区管理员不定期组织线上线下互动活动，为粉丝提供交流和展示的平台。最近一次线上活动吸引了超过五千名粉丝参与，创造了社区互动的新纪录。</p>`,
    category: 'community',
    categoryName: '粉丝社区',
    date: '2026-07-25',
    readTime: 7,
    tags: ['佐山爱', '粉丝社区', '粉丝互动', '社群文化'],
    heroImage: 'https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20Japanese%20community%20gathering%20aesthetic%20with%20soft%20golden%20lighting%2C%20minimalist%20modern%20interior%20with%20natural%20wood%20elements%2C%20cream%20and%20warm%20beige%20tones%2C%20cozy%20sophisticated%20atmosphere%2C%20editorial%20lifestyle%20photography%2C%20no%20people&width=1200&height=500&seq=article-7-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20Japanese%20community%20gathering%20aesthetic%20with%20soft%20golden%20lighting%2C%20minimalist%20modern%20interior%20with%20natural%20wood%20elements%2C%20cream%20and%20warm%20beige%20tones%2C%20cozy%20sophisticated%20atmosphere%2C%20editorial%20lifestyle%20photography%2C%20no%20people&width=600&height=350&seq=article-7-hero&orientation=landscape',
    relatedArticles: ['article-5', 'article-6', 'article-3'],
    faqItems: [],
  },
  {
    id: 'article-8',
    title: '佐山爱的时尚风格演变：从清新到优雅',
    summary: '梳理佐山爱出道以来的时尚风格变化，从早期的清新甜美到如今的优雅成熟，见证她的时尚蜕变之路。',
    content: `<p>佐山爱的时尚风格随着她事业的发展不断演进，每一个阶段都展现出独特的魅力和品味。</p>
<h2>早期风格</h2>
<p>刚出道时的佐山爱以清新甜美的形象示人。那时的她偏爱浅色系服装，搭配简约的首饰，整体造型充满了少女般的纯真感。这种风格与她当时的定位十分契合，也为她赢得了第一批忠实粉丝。</p>
<h2>转型期</h2>
<p>随着经验的积累，佐山爱开始尝试更多元的造型风格。她不再局限于单一的形象，而是在不同场合展现出截然不同的气质。这一时期的她开始在时尚活动中频繁亮相，逐渐建立起了自己独特的时尚标签。</p>
<h2>成熟期</h2>
<p>如今的佐山爱已经形成了成熟优雅的个人风格。她善于运用经典单品打造高级感造型，同时又不失个性。在最新的公开活动中，她身着一袭剪裁精良的连衣裙亮相，搭配简约而精致的配饰，尽显成熟女性的从容与优雅。</p>`,
    category: 'profile',
    categoryName: '个人资料',
    date: '2026-07-22',
    readTime: 8,
    tags: ['佐山爱', '时尚风格', '造型演变', '穿搭'],
    heroImage: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20fashion%20editorial%20aesthetic%20with%20soft%20directional%20lighting%2C%20minimalist%20gallery%20white%20space%20background%20with%20subtle%20warm%20undertones%2C%20sophisticated%20refined%20luxury%20atmosphere%2C%20cream%20and%20champagne%20tones%2C%20artistic%20composition%2C%20no%20people&width=1200&height=500&seq=article-8-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20fashion%20editorial%20aesthetic%20with%20soft%20directional%20lighting%2C%20minimalist%20gallery%20white%20space%20background%20with%20subtle%20warm%20undertones%2C%20sophisticated%20refined%20luxury%20atmosphere%2C%20cream%20and%20champagne%20tones%2C%20artistic%20composition%2C%20no%20people&width=600&height=350&seq=article-8-hero&orientation=landscape',
    relatedArticles: ['article-1', 'article-4', 'article-5'],
    faqItems: [],
  },
  {
    id: 'article-9',
    title: '佐山爱出道五周年纪念特辑',
    summary: '在佐山爱出道五周年之际，回顾她在这五年间的成长与成就，以及她对粉丝的真诚感谢。',
    content: `<p>时光荏苒，转眼间佐山爱已经出道五周年。这五年间，她从一名新人成长为行业的中坚力量，收获了无数粉丝的喜爱和支持。</p>
<h2>五年回顾</h2>
<p>五年来，佐山爱参与了数十部作品的拍摄，举办了多场粉丝见面会，社交媒体粉丝数突破百万。这些数字背后，是她日复一日的努力和坚持。</p>
<h2>感恩粉丝</h2>
<p>在五周年纪念活动中，佐山爱特别录制了一段感谢视频。她在视频中动情地说："没有你们的支持，就没有今天的我。这五年是我人生中最宝贵的时光，感谢有你们一路相伴。"</p>
<h2>未来展望</h2>
<p>展望下一个五年，佐山爱表示将继续努力，为粉丝带来更多优质的作品和惊喜。"我会继续成长，希望大家能继续见证我的每一步。"</p>`,
    category: 'debut',
    categoryName: '出道经历',
    date: '2026-07-18',
    readTime: 10,
    tags: ['佐山爱', '五周年', '出道纪念', '成长回顾'],
    heroImage: 'https://readdy.ai/api/search-image?query=Japanese%20celebration%20aesthetic%20with%20warm%20glowing%20candlelight%20and%20delicate%20golden%20confetti%2C%20minimalist%20elegant%20composition%20on%20cream%20silk%20background%2C%20sophisticated%20festive%20yet%20refined%20atmosphere%2C%20warm%20amber%20and%20champagne%20tones%2C%20no%20people&width=1200&height=500&seq=article-9-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Japanese%20celebration%20aesthetic%20with%20warm%20glowing%20candlelight%20and%20delicate%20golden%20confetti%2C%20minimalist%20elegant%20composition%20on%20cream%20silk%20background%2C%20sophisticated%20festive%20yet%20refined%20atmosphere%2C%20warm%20amber%20and%20champagne%20tones%2C%20no%20people&width=600&height=350&seq=article-9-hero&orientation=landscape',
    relatedArticles: ['article-1', 'article-2', 'article-6'],
    faqItems: [],
  },
];

export const featuredArticles = ['article-1', 'article-3', 'article-6', 'article-4'];

export const testimonials = [
  {
    id: 1,
    name: '张先生',
    role: '资深粉丝',
    content: '关注佐山爱已经三年了，她的每一部作品都让我感受到她对表演的热爱和专注。这个网站整理了她的完整资料，对新粉丝来说是很好的入门指南。',
    rating: 5,
  },
  {
    id: 2,
    name: '李女士',
    role: '娱乐编辑',
    content: '作为娱乐行业的从业者，我认为佐山爱是一位非常专业的艺人。她的敬业精神和对作品质量的要求令人敬佩。这个资料站的信息准确全面，是我工作的重要参考。',
    rating: 5,
  },
  {
    id: 3,
    name: '王先生',
    role: '写真收藏家',
    content: '佐山爱的写真集是我收藏中最重要的部分。她的镜头表现力极强，每一本写真集都有独特的艺术风格。这个网站的分类整理做得很用心，方便查找。',
    rating: 5,
  },
  {
    id: 4,
    name: '陈小姐',
    role: '粉丝社区管理员',
    content: '作为粉丝社区的管理员，我非常欣赏这个网站的开放包容态度。它不仅提供了丰富的资料，还在社区板块为粉丝提供了一个温暖的交流平台。',
    rating: 4,
  },
];

export const homeFAQ = [
  {
    question: '佐山爱是谁？',
    answer: '佐山爱（Sayama Ai）是一位日本知名影视女演员，以其出色的表演才华和独特的个人魅力在华语圈也收获了大量粉丝的关注与喜爱。',
  },
  {
    question: '佐山爱有哪些代表作品？',
    answer: '佐山爱拥有丰富的作品库，涵盖多种题材的影视作品和多本精美写真集。本站代表作品栏目中有详细的作品分类和介绍，方便粉丝查阅。',
  },
  {
    question: '如何获取佐山爱的最新动态？',
    answer: '您可以通过本站的"最新动态"栏目获取佐山爱的最新活动安排、社交媒体更新及新作品发布信息。也可以关注她的官方社交媒体账号。',
  },
  {
    question: '佐山爱有粉丝社区吗？',
    answer: '是的，佐山爱拥有活跃的全球粉丝社区。本站"粉丝社区"栏目汇总了社区动态、粉丝活动和精彩互动内容，欢迎加入。',
  },
  {
    question: '在哪里可以购买佐山爱的写真集？',
    answer: '佐山爱的写真集可通过官方渠道及各大线上书店购买。本站会在相关文章中提供最新购买信息，请持续关注。',
  },
];

export const stats = [
  { label: '作品总数', value: '120+', icon: 'ri-film-line' },
  { label: '写真集', value: '16', icon: 'ri-camera-line' },
  { label: '粉丝数', value: '100万+', icon: 'ri-heart-line' },
  { label: '出道年数', value: '5+', icon: 'ri-star-line' },
];